// extracted by mini-css-extract-plugin
export default {"btn":"paypalBtn_btn__nYfS4"};